/**
 * "You have a session waiting for your review" — the answer to "where do I leave it?".
 * Sits at the top of the Sessions & Coaching page and on My Bookings.
 */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Star } from 'lucide-react';
import { API } from '@/App';

const styles = `
  .prb { background:#fffaf0; border:1px solid #e8d9a8; border-left:4px solid #c8a84a;
         border-radius:12px; padding:16px 18px; margin-bottom:20px; }
  .prb-head { display:flex; align-items:center; gap:8px; font-weight:600; color:#5a4a10;
              font-size:.98rem; margin-bottom:10px; }
  .prb-row { display:flex; align-items:center; justify-content:space-between; gap:14px;
             flex-wrap:wrap; padding:8px 0; border-top:1px solid #f0e6c8; }
  .prb-row:first-of-type { border-top:0; }
  .prb-meta { font-size:.88rem; color:#6a5a2a; }
  .prb-btn { background:#1a5a44; color:#fff; border:0; border-radius:999px; padding:9px 20px;
             font-size:.88rem; font-weight:600; cursor:pointer; transition:background .2s ease; }
  .prb-btn:hover { background:#134534; }
`;

export const PendingReviewsBanner = () => {
  const [pending, setPending] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/session-feedback/pending`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((r) => setPending(r.data.pending || []))
      .catch(() => setPending([]));
  }, []);

  if (pending.length === 0) return null;

  return (
    <div className="prb" data-testid="pending-reviews-banner">
      <style>{styles}</style>
      <div className="prb-head">
        <Star className="w-4 h-4" />
        {pending.length === 1
          ? 'One session is waiting for your review'
          : `${pending.length} sessions are waiting for your review`}
      </div>
      {pending.map((item) => (
        <div className="prb-row" key={item.booking_id}>
          <span className="prb-meta">
            <strong>{item.session_title}</strong> with {item.practitioner_name} ·{' '}
            {item.days_left === 0 ? 'last day to review' : `${item.days_left} day${item.days_left === 1 ? '' : 's'} left`}
          </span>
          <button
            className="prb-btn"
            onClick={() => navigate(item.review_url)}
            data-testid={`leave-review-btn-${item.booking_id}`}
          >
            Leave a review
          </button>
        </div>
      ))}
    </div>
  );
};

export default PendingReviewsBanner;
